export const chip = {
  root: {
    class: ['inline-flex', 'items-center', 'rounded-full', 'text-white', 'uppercase font-bold'],
  },
  image: {
    class: ['w-6 h-6 -ml-2.5 mr-2', 'rounded-full'],
  },
  icon: {
    class: 'leading-6 mr-1.5 h-3.5',
  },
  label: {
    class: 'mx-0',
  },
  removeIcon: {
    class: [
      'rounded-md leading-6',
      'ml-2',
      'w-4 h-4',
      'transition duration-200 ease-in-out',
      'cursor-pointer',
    ],
  },
};
